import {observer} from 'mobx-react';
import {EmployeeCustomFields} from 'main/components';
import CustomField from 'shared/components/CustomField';

const OnboardEmployeeCustomFieldsForm = observer(({uiState}) => {
  const {employee, errors} = uiState;

  return (
    <EmployeeCustomFields employeeCustomFields={employee.employeeCustomFields} category='personal' errors={errors} useFormLayout>
      {(employeeCustomField, error) => (
        <CustomField
          customField={employeeCustomField}
          key={employeeCustomField.id}
          errorMessage={error ? error.value : null}
        />
      )}
    </EmployeeCustomFields>
  );
});

export default OnboardEmployeeCustomFieldsForm;
